export const insertIcon = (parent, width, height, pathDrawn) => {
    const icon = createIcon(width, height)
    insertPath(icon, "white", pathDrawn)

    parent.appendChild(icon)
}

export const createIcon = (width, height) => {
    const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg")
    icon.setAttributeNS(null, "width", width)
    icon.setAttributeNS(null, "height", height)
    icon.setAttributeNS(null, "viewBox", `0 0 ${width} ${height}`)
    icon.setAttributeNS(null, "fill", "none")

    return icon
}

export const insertPath = (parent, fill = null, pathDrawn) => {
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path")
    path.setAttributeNS(null, "fill-rule", "evenodd");
    path.setAttributeNS(null, "clip-rule", "evenodd");
    path.setAttributeNS(null, "d", pathDrawn);

    if(fill) {
        path.setAttributeNS(null, "fill", fill);
    }

    parent.appendChild(path)
}


// WEBPACK FOOTER //
// ./javascript/product-search-page/utils/iconUtils.js